export const USER = 'v2/missions,lookup-customer-by-token';
export const COMPANY = `${process.env.REACT_APP_API_BASE_URL}/company/lookup/`;
export const VEHICLE = 'v2/missions,lookup-customer-vehicle-by-token';
export const SCHEDULE_MISSION = 'v2/missions,schedule-by-token';
export const CANCEL_MISSION = 'v2/missions,cancel-by-token';
export const GET_MISSION_BY_ID = 'v2/missions,by-short-id';
export const CONTRACT_CUSTOMER = `${process.env.REACT_APP_API_BASE_URL}/v1/contract-customers,lookup`;
export const MISSIONS = `${process.env.REACT_APP_RESQUE_BASE_URL}/v1/missions,transport`;
export const REGISTER = `${process.env.REACT_APP_API_BASE_URL}/v1/contract-customers,register`;
export const GET = 'GET';
export const POST = 'POST';
export const API_KEY = `&key=${process.env.REACT_APP_GOOGLE_API_KEY}`;

export const GOOGLE_PLACES = 'https://maps.googleapis.com/maps/api/place/autocomplete/json?input=';
export const GOOGLE_INIT_PLACES = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_API_KEY}&libraries=places`;
export const GOOGLE_GEOCODE = 'https://maps.googleapis.com/maps/api/geocode/json?';
